export default __webpack_public_path__ + "static/media/151-electric.3225a1d1.png";